ixModuleRouting('impactx.b2b', {
    '/customercompanies/:userId': {
        templateUrl: 'modules/b2b/templates/customercompanies.html',
        process: "AssignCustomerCompanies",
        controller: 'CustomerCompaniesListCtrl',
        controllerAs: 'customerCompaniesListCtrl',
        workspace: 'admin'
    },
    '/customerconfigurations': {
        templateUrl: 'modules/b2b/templates/customerconfigurations.html',
        process: "EditCustomerConfigurations",
        controller: 'CustomerConfigurationsListCtrl',
        controllerAs: 'customerConfigurationsListCtrl',
        workspace: 'content'
    },
    '/customerconfiguration/:id': {
        templateUrl: 'modules/b2b/templates/customerconfiguration.html',
        process: "EditCustomerConfigurations",
        controller: 'CustomerConfigurationCtrl',
        controllerAs: 'customerConfigurationCtrl',
        workspace: 'content'
    }
});